import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import { getAccountsForCalling,getSiteListingFilters } from "../../../service/Referral/action";
import SitesCalling from "./sitesCalling";

const mapStateToProps = (state) => ({
    referralAccountList:state.Referral.referralAccountList,
    siteCallingfilters:state.Referral.siteCallingfilters,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAccountsForCalling,
            getSiteListingFilters
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SitesCalling);
